"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  name: "Link to another record",
  value: "linkToRecord"
}, {
  name: "Single line text",
  value: "singleLineText",
  desc: "A single line of text. You can optionally prefill each new cell with a default value:"
}, {
  name: "Long text",
  value: "longText",
  desc: "A long text field that can span multiple lines"
}, {
  name: "Number",
  value: "number"
}, {
  name: "Attachment",
  value: "attachment",
  desc: "Attachments allow you to add images, documents, or other files which can then be viewed or downloaded."
}, {
  name: "Checkbox",
  value: "checkBox",
  desc: "A single checkbox that can be checked or unchecked."
}, {
  name: "Multiple select",
  value: "multiSelect",
  desc: "Multiple select allows you to select one or more predefined options listed below."
}, {
  name: "Single select",
  value: "singleSelect",
  desc: "Single select allows you to select one options listed below."
}, {
  name: "Collaborator",
  value: "collaborator"
}, {
  name: "Date",
  value: "date",
  desc: "Pick one from a calendar."
}, {
  name: "Phone number",
  value: "phoneNumber"
}, {
  name: "Email",
  value: "email"
}, {
  name: "URL",
  value: "url"
}, {
  name: "Currency",
  value: "currency"
}, {
  name: "Percent",
  value: "percent"
}, {
  name: "Duration",
  value: "duration",
  desc: "A duration of time in minutes or seconds (e.g. 1:23)."
}, {
  name: "Rating",
  value: "rating"
}, {
  name: "Formula",
  value: "formula",
  desc: "Compute a value in each record based on other fields in the same record"
}, // { name: "Rollup", value: "rollup" },
{
  name: "Count",
  value: "count"
}, {
  name: "Lookup",
  value: "lookup"
}, {
  name: "Created time",
  value: "createdAt"
}, {
  name: "Last modified time",
  value: "updatedAt"
}, {
  name: "Created by",
  value: "createdBy"
}, {
  name: "Last modified by",
  value: "updatedBy"
}, {
  name: "Autonumber",
  value: "autoNumber"
}, {
  name: "Barcode",
  value: "barcode",
  desc: "Use the Kontenbase iOS or Android app to scan barcodes."
}, // { name: "Button", value: "button" },
{
  name: "Password",
  value: "password"
}];
exports["default"] = _default;